import axios, { AxiosResponse } from 'axios'
import { ID, WoosatTelecomResponse, Response } from '../../../../../_metronic/helpers'
import { GroupPricing, GroupPricingQueryResponse } from './_models'
import toast from 'react-hot-toast'

const API_URL = process.env.REACT_APP_THEME_API_URL
const GROUPPRICING_URL = `${API_URL}/admin/group-pricings`
const GET_GROUPPRICINGS_URL = `${API_URL}/admin/group-pricings`

const getGroupPricings = (query: string): Promise<GroupPricingQueryResponse | WoosatTelecomResponse<GroupPricing[]>> => {
  return axios
    .get(`${GET_GROUPPRICINGS_URL}?${query}`)
    .then((d: AxiosResponse<WoosatTelecomResponse<GroupPricing[]>>) => {
      return d.data
    })
}

const getGroupPricingById = async (id: ID): Promise<GroupPricing> => {
  try {
    const { data } = await axios.get(`${GROUPPRICING_URL}/${id}`)
    return data?.data?.group_pricing
  } catch (error: any) {
    console.log('Error: ', error.message)
    return {}
  }
}

const createGroupPricing = (grouppricing: GroupPricing): Promise<GroupPricing | undefined> => {
  const formData = new FormData()
  Object.entries(grouppricing).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      formData.append(key, value.toString())
    }
  })

  return axios
    .post(GROUPPRICING_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response: any) => {
      if (response.data.success === true) {
        toast.success(response.data.message, { position: 'top-right' })
      } else {
        toast.error(response?.data?.message, { position: 'top-right' })
      }
      return response.data
    })
    .then((response: Response<GroupPricing>) => response.data)
}

const updateGroupPricing = (grouppricing: GroupPricing): Promise<GroupPricing | undefined> => {
  const newFormData = new FormData()
  Object.entries(grouppricing).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      newFormData.append(key, value.toString())
    }
  })

  return axios
    .post(`${GROUPPRICING_URL}/${grouppricing.id}`, newFormData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response: any) => {
      if (response.data.success === true) {
        toast.success(response.data.message, { position: 'top-right' })
      } else {
        toast.error(response?.data?.message, { position: 'top-right' })
      }
      return response.data
    })
    .then((response: Response<GroupPricing>) => response.data)
}

const deleteGroupPricing = (grouppricingId: ID): Promise<void> => {
  return axios.delete(`${GROUPPRICING_URL}/${grouppricingId}`).then((response) => {
    if (response.data.success === true) {
      toast.success(response?.data?.message, { position: 'top-right' })
    } else {
      toast.error(response?.data?.message, { position: 'top-right' })
    }
  })
}

const deleteSelectedGroupPricings = (grouppricingIds: Array<ID>): Promise<void> => {
  const requests = grouppricingIds.map((id) => axios.delete(`${GROUPPRICING_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {
  getGroupPricings,
  deleteGroupPricing,
  deleteSelectedGroupPricings,
  getGroupPricingById,
  createGroupPricing,
  updateGroupPricing,
}
